<div class="flex h-full items-center" *transloco="let t">
  <button
    class="btn inline-flex border border-president-100 bg-white px-md text-president-100"
    (click)="showSideMenu()"
  >
    <fa-icon [icon]="faBars"></fa-icon>
  </button>
</div>
